import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertCircle, Clock3 } from "lucide-react";

/**
 * DisagreementsBanner. top-of-case reminder.
 * Polls the disagreement-reminders endpoint and shows a single, calm banner if
 * the user has either:
 * - items they disagreed with but haven't raised yet, OR
 * - items raised more than 7 days ago with no captured agent response.
 * Clicking jumps to the Inspections tab.
 */
export default function DisagreementsBanner({ caseId, onGoToInspections }) {
 const [data, setData] = useState(null);

 useEffect(() => {
 let mounted = true;
 api.get(`/cases/${caseId}/disagreement-reminders`).then(({ data }) => {
 if (mounted) setData(data);
 }).catch(() => {});
 return () => { mounted = false; };
 }, [caseId]);

 if (!data) return null;
 const { needs_raising_count: nr, overdue_chase_count: oc } = data;
 if (!nr && !oc) return null;

 return (
 <button
 onClick={onGoToInspections}
 className="w-full text-left card bg-[#FAF7F0] border-l-4 border-l-[#B35D4C] hover:bg-[#F5EFE2] transition-colors mb-6"
 data-testid="disagreements-banner"
 >
 <div className="flex items-start gap-3">
 <AlertCircle size={20} strokeWidth={1.5} className="text-[#B35D4C] mt-0.5 flex-shrink-0" />
 <div className="flex-1">
 <div className="label-mono text-[#B35D4C] mb-1">Condition report disagreements</div>
 <p className="font-serif text-base text-[#1A1A1A] leading-snug">
 {nr > 0 && (
 <>You have <strong>{nr}</strong> item{nr === 1 ? "" : "s"} you marked as disagreed but haven't raised with the agent yet. </>
 )}
 {oc > 0 && (
 <span className="inline-flex items-center gap-1.5 text-[#8A6D3B]">
 <Clock3 size={13} strokeWidth={1.5} />
 {oc} raised &gt; 7 days ago. no reply logged.
 </span>
 )}
 </p>
 <p className="text-xs text-[#6B7280] mt-1">Tap to open Inspections.</p>
 </div>
 </div>
 </button>
 );
}
